import React from "react";
import { Phone, CreditCard, Banknote, ShoppingBag, UtensilsCrossed, Truck } from "lucide-react";
import { useSection } from "@/context/SiteContext";
import { telHref } from "@/lib/site";

export default function OrderSection() {
  const o = useSection("order");
  const contact = useSection("contact");
  const tel = telHref(contact.phone_tel, contact.phone);

  return (
    <section id="bestall" className="py-16 md:py-24 bg-[var(--surface-alt)]">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center space-y-8">
        <span className="inline-block text-xs uppercase tracking-[0.22em] font-semibold text-[var(--primary)]">
          {o.eyebrow || "Beställning"}
        </span>
        <h2 className="font-serif-display text-4xl sm:text-5xl font-black tracking-tight">{o.title || "Beställ enkelt"}</h2>
        <p className="text-lg text-[var(--text-muted)] max-w-2xl mx-auto">{o.description}</p>

        <div className="grid sm:grid-cols-3 gap-4 max-w-3xl mx-auto pt-4">
          {[
            { Icon: ShoppingBag, title: o.card_1_title || "Avhämtning", desc: o.card_1_desc || "Hämta maten färdigpackad" },
            { Icon: UtensilsCrossed, title: o.card_2_title || "Servering", desc: o.card_2_desc || "Njut i vår lokal" },
            { Icon: Truck, title: o.card_3_title || "Leverans", desc: o.card_3_desc || "Levererat hem till dig" },
          ].map(({ Icon, title, desc }) => (
            <div key={title} className="bg-white border border-[var(--border)] rounded-2xl p-6 text-left">
              <Icon size={22} className="text-[var(--primary)]" />
              <div className="mt-3 font-bold">{title}</div>
              <div className="text-sm text-[var(--text-muted)] mt-1">{desc}</div>
            </div>
          ))}
        </div>

        <div className="flex items-center justify-center gap-4 pt-2">
          <span className="text-sm font-semibold text-[var(--text-muted)]">Betalning:</span>
          <div className="flex items-center gap-2 text-sm">
            <CreditCard size={16} className="text-[var(--primary)]" /> Kort
          </div>
          <span className="text-[var(--border)]">•</span>
          <div className="flex items-center gap-2 text-sm">
            <Banknote size={16} className="text-[var(--primary)]" /> Kontant
          </div>
        </div>

        <div className="flex flex-wrap justify-center gap-3 pt-4">
          <a href={tel} data-testid="order-call-now" className="inline-flex items-center gap-2 rounded-full bg-[var(--primary)] hover:bg-[var(--primary-hover)] text-white px-7 py-4 font-semibold shadow-lg shadow-[var(--primary)]/20 transition-all hover:-translate-y-0.5">
            <Phone size={18} /> {o.cta_primary || "Ring nu"}
          </a>
          <a href={tel} data-testid="order-online-cta" className="inline-flex items-center gap-2 rounded-full bg-white text-[var(--text)] border border-[var(--border)] hover:border-[var(--text)] px-7 py-4 font-semibold transition-colors">
            {o.cta_secondary || "Beställ online"}
          </a>
        </div>
      </div>
    </section>
  );
}
